<div mat-dialog-title>RAIN Sabre login expired</div>
<mat-dialog-content>
  <div class="dialog-main-text">
    Sabre login has either taken a snooze and expired or password was recently updated. Any reservation changes are unsaved and must be
    processed again after logging back into RAIN.
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button class="mat-mdc-unelevated-button" mat-dialog-close>Log in again</button>
</mat-dialog-actions>
